import { Api } from 'utils';

class ReportService {
		
	static admin = {
		getPayments: async (params?: any) => Api.createResponse('admin/reports/payments',params),
		downloadPayments: async (params?: any) => Api.createResponse('admin/reports/payments/download',params),
		getPoints: async (params?: any) => Api.createResponse('admin/reports/points',params),
		getPointsData: async (params?: any) => Api.createResponse('admin/reports/points/data',params),
		downloadPoints: async (params?: any) => Api.createResponse('admin/reports/points/download',params),
		getSettings: async (params?: any) => Api.createResponse('admin/reports/points/settings',params),
		saveSettings: async (params?: any) => Api.createResponse('admin/reports/points/save-settings',params),
		getExcelReport: async (params?: any) => Api.createResponse('admin/reports/excel-report',params),
		getPremiumReport: async (params?: any) => Api.createResponse('admin/reports/premium-report',params),
		getBillingReport: async (params?: any) => Api.createResponse('admin/reports/billing-report',params),
		newDownloadPayments: async (params?: any) => Api.createResponse('admin/reports/payments/new-download',params),
	}

}

export default ReportService;